import enUS from "./en-US";
import type { ErrorKey } from "./en-US";
import esES from "./es-ES";
import { WaterlyLocale } from "./types";
import type { LocaleNamespace, LocaleNamespaceName } from "./types";
export { WaterlyLocale } from "./types";

// We use en-US as the source of error keys
export type { ErrorKey };

export const locales: Record<WaterlyLocale, Record<LocaleNamespaceName, LocaleNamespace>> = {
  [WaterlyLocale.enUS]: enUS,
  [WaterlyLocale.esES]: esES,
};
